import { HeaderNavigation } from '@theme'
import { LoginLogoutLink } from './login-logout-link'
import { routeModule } from '~/features/route-module'
import { useSelect } from '~/store'

export function OrganizationLoggedOutHeader() {
  const homeHref = useMarketingPageHref()
  return (
    <HeaderNavigation backHref={homeHref}>
      <LoginLogoutLink />
    </HeaderNavigation>
  )
}

/**
 * Get the link to the marketing home page
 * If the app is hosted at app.<something>.com, the marketing home page is <something>.com
 */
function useMarketingPageHref() {
  const origin = useSelect('route', (s) => s.location.origin)
  return origin.replace('//app.', '//')
}
